import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Palette — 4 colour dots pulse in round-robin so the swatches feel
 *  alive. Outer palette shape stays fixed; stagger is 160 ms apart. */
export function IcnPalette(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="palette">
      <path d="M8 2a6 6 0 0 0 0 12 1.5 1.5 0 0 0 0.8-2.8 1 1 0 0 1 0.5-1.9H11a3 3 0 0 0 3-3A6 6 0 0 0 8 2z" />
      {[
        { cx: 5, cy: 6, delay: '0s' },
        { cx: 8, cy: 4.5, delay: '0.16s' },
        { cx: 10.8, cy: 6, delay: '0.32s' },
        { cx: 11.2, cy: 9, delay: '0.48s' },
      ].map((d) => (
        <circle key={d.delay} cx={d.cx} cy={d.cy} r="0.9" fill="currentColor" stroke="none">
          {animate && (
            <animate
              attributeName="r"
              values="0.9;1.3;0.9"
              keyTimes="0;0.5;1"
              dur="2s"
              begin={d.delay}
              repeatCount="indefinite"
            />
          )}
        </circle>
      ))}
    </Svg>
  );
}
